import { City } from './cities'
import { destinationEnum, getDestinationFromAPI } from './destination'
import { Theme } from './theme'

enum ExcludesVersion {
  Drive = 1,
  PickASide,
  Other,
}

function getExcludesVersion(destination?: destinationEnum): ExcludesVersion {
  if (typeof destination === 'undefined') {
    return ExcludesVersion.Drive
  } else if (
    [destinationEnum.allOfEurope, destinationEnum.outsideEurope].includes(
      destination,
    )
  ) {
    return ExcludesVersion.Other
  } else {
    return ExcludesVersion.PickASide
  }
}

export function isOffer(theme: Theme) {
  const isNormal = [Theme.fly, Theme.drive, Theme.multiDrive].includes(theme)
  return isNormal && new Date() < new Date(2019, 4, 1)
}

export function getExcludedCitiesContentKey(
  theme: Theme,
  destination: destinationEnum,
  contentKey: string = 'exclude-cities',
): string {
  switch (getExcludesVersion(destination)) {
    case ExcludesVersion.Drive:
      contentKey += '-drive'
      break
    case ExcludesVersion.PickASide:
      contentKey += '-pickaside'
      break
    case ExcludesVersion.Other:
    default:
      contentKey += '-other'
      break
  }
  if (isOffer(theme)) {
    contentKey += '-offer'
  }
  return contentKey
}

export function getMaxExcludedCities(
  theme: Theme,
  destination: destinationEnum,
): number {
  // If less than May 2019 then offer double exclusions
  const offer = isOffer(theme) ? 2 : 1

  switch (getExcludesVersion(destination)) {
    case ExcludesVersion.Drive:
      return 3 * offer
    case ExcludesVersion.PickASide:
      return 1 * offer
    case ExcludesVersion.Other:
    default:
      return 3 * offer
  }
}

export function filterDestination(
  excludedCities: City[],
  theme: Theme,
  destination: destinationEnum,
  max?: number,
) {
  max = max || getMaxExcludedCities(theme, destination)
  if (
    ![destinationEnum.allOfEurope, destinationEnum.outsideEurope].includes(
      destination,
    )
  ) {
    const filtered = excludedCities.filter(
      x => getDestinationFromAPI(x.direction) === destination,
    )
    const notFiltered = excludedCities.filter(
      x => getDestinationFromAPI(x.direction) !== destination,
    )
    if (excludedCities.length > 0 && filtered.length < max) {
      return filtered.concat(notFiltered.slice(0, max - filtered.length))
    } else {
      return filtered.slice(0, max)
    }
  }
  return excludedCities
}
